import type { FilterConfig } from '@/types/filters.types';
import { leadSourceFilterConfig } from '@/hooks/filters/leadSourceOptions';

/**
 * Filter keys MUST match the canonical legacy filter registry.
 * DO NOT rename keys or change option values — dynamic lists store these permanently.
 * See lib/filterRegistry.ts for the full registry and rules.
 */
export function buildPatientFilterConfigs(coordLabel: string): FilterConfig[] {
  return [
    { key: 'search', label: 'Search', type: 'search', allLabel: 'Search patients...' },
    { key: 'membership-status', label: 'Status', type: 'select', allLabel: 'All statuses', multi: true },
    // Member / non-member right now — same key and values as the appointments list.
    { key: 'member-status', label: 'Membership', type: 'select', allLabel: 'All patients', multi: true },
    leadSourceFilterConfig('Referral Source', 'All sources'),
    { key: 'coordinator', label: coordLabel, type: 'select', allLabel: `All ${coordLabel.toLowerCase()}s`, multi: true },
    { key: 'tags', label: 'Tag', type: 'select', allLabel: 'All tags', multi: true },
    { key: 'facility', label: 'Facility', type: 'select', allLabel: 'All facilities', multi: true },
    { key: 'daterange', label: 'Created Date', type: 'daterange' },
    { key: 'dob', label: 'Date of Birth', type: 'daterange' },
  ];
}
